import React, { useContext, useEffect, useState } from 'react';

import ManualTextForm from '../../../MtUmet/components/manual-text-form/ManualTextForm';
import { TenantIdContext } from '../../../../components/app/App';
import { Header } from '../header/Header';
import { useHistory } from 'react-router';
import { getTenantWorkflowById } from '../../services/api-calls';

const WorkflowTesting = ({ match }) => {
  const history = useHistory();
  const tenantId = useContext(TenantIdContext);
  const [loadedTenantId, setLoadedTenantId] = useState('');
  const [workflowData, setWorkflowData] = useState(null);

  useEffect(() => {
    if (loadedTenantId && loadedTenantId !== tenantId) {
      return;
    }
    getTenantWorkflowById(tenantId, match.params.id).then(response => {
      const workflowFromResponse = response?.data;
      if (!workflowFromResponse || !workflowFromResponse?.workflowId || !workflowFromResponse?.workflowName) {
        history.push('/workflows');
      }
      setWorkflowData(workflowFromResponse);
      setLoadedTenantId(tenantId);
    });
  }, [match, tenantId, history, loadedTenantId]);
  return (
    <div className="w-100 h-100 p-1 d-flex flex-column">
      <Header workflowData={workflowData} currentPage="test" />
      <ManualTextForm workflowId={workflowData?.workflowId} disableWorkflowSelection />
    </div>
  );
};

export default WorkflowTesting;
